<template>
    <div>
        <nav-bar></nav-bar>
        <div class="content">
            <nav-left-bar :active="0"></nav-left-bar>
            <div class="rg">
                <div class="tit">
                    <div class="l">
                        <img src="../../assets/icon/bg.png" alt="" />
                        <div class="tc">
                            {{ device_info.name }}
                        </div>
                    </div>
                </div>
                <div class="details">
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">申请信息</div>
                    </div>
                    <div class="line"></div>
                    <div style="height:15px;"></div>
                    <div class="lk">
                        <label>设备名称：</label>
                        <input
                            type="text"
                            :value="device_info.name"
                            disabled
                        />
                    </div>
                    <div class="lk">
                        <label>预约人：</label>
                        <input
                            type="text"
                            placeholder="请输入姓名"
                            v-model="name" disabled
                        />
                    </div>
                    <div class="lk">
                        <label>联系方式：</label>
                        <input
                            type="text"
                            v-model="mobile"
                            placeholder="请输入手机号" disabled
                        />
                    </div>
                    <div class="lk">
                        <label>预约主题：</label>
                        <input
                            type="text"
                            placeholder="请输入预约主题"
                            v-model="object"
                        />
                    </div>
                    <div class="lk speak">
                        <label>预约说明：</label>
                        <textarea
                            placeholder="请输入预约说明"
                            v-model="speak"
                        ></textarea>
                    </div>
                    <div style="height:100px;"></div>
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">在线预约</div>
                    </div>
                    <div class="line"></div>

                    <!-- 选择插件 -->
                    <div style="height:32px"></div>
                    <!-- <month></month> -->

                    <!-- 时间选择 -->
                    <div class="time-select">
                        <div class="start">
                            <div class="start-time">开始时间：</div>
                            <el-date-picker
                                v-model="startTime"
                                type="date"
                                placeholder="选择日期"
                                style="margin-left:20px;margin-right:30px"
                                @change="startChange"
                            >
                            </el-date-picker>
                            <el-select v-model="value1" placeholder="请选择">
                                <el-option
                                    v-for="item in timelist"
                                    :key="item.time"
                                    :label="item.time"
                                    :value="item.time"
                                    :disabled="item.type == 1 ? false : true"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="end">
                            <div class="start-time">结束时间：</div>
                            <el-date-picker
                                v-model="endTime"
                                type="date"
                                placeholder="选择日期"
                                style="margin-left:20px;margin-right:30px"
                                @change="endChange"
                            >
                            </el-date-picker>
                            <el-select v-model="value2" placeholder="请选择">
                                <el-option
                                    v-for="item in timelist"
                                    :key="item.time"
                                    :label="item.time"
                                    :value="item.time"
                                    :disabled="item.type == 1 ? false : true"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>

                    <div style="height:42px;"></div>
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">温馨提示</div>
                    </div>
                    <div class="line"></div>

                    <div class="zhushi">
                        注：每个小块15分钟，蓝色表示已被预约，黄色表示审批中，绿色表示用户选择。
                    </div>
                    <div class="replay">
                        <div class="left" @click="applys">提交</div>
                        <div class="right" @click="goback">取消</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "appointmentApply",
    data() {
        return {
            startTime: "",
            endTime: "",
            value1: "",
            value2: "",
            device_info: {},
            name: localStorage.getItem('username'),
            mobile: localStorage.getItem('mobile'),
            object: "",
            speak: "",
            time: "",
            apply: [],
            pass: [],
            timelist: []
        };
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
        timezh(d) {
            var month = "",
                day = "";
            if (d.getMonth() < 9) {
                month = "0" + (d.getMonth() + 1);
            } else {
                month = d.getMonth() + 1;
            }
            if (d.getDate() < 9) {
                day = "0" + d.getDate();
            } else {
                day = d.getDate();
            }
            return d.getFullYear() + "-" + month + "-" + day;
        },
        startChange() {
            var d = new Date(this.startTime);
            this.time = this.timezh(d);
            this.startTime = this.timezh(d);
            this.details();
        },
        endChange() {
            var d = new Date(this.endTime);
            this.time = this.timezh(d);
            this.endTime = this.timezh(d);
            this.details();
        },
        applys() {
            if (this.object == "") {
                this.$toast("预约主题不能为空");
                return;
            }
            if (this.speak == "") {
                this.$toast("预约说明不能为空");
                return;
            }
            if (this.startTime == "") {
                this.$toast("开始时间不能为空");
                return;
            }
            if (this.value1 == "") {
                this.$toast("开始时间点不能为空");
                return;
            }
            if (this.endTime == "") {
                this.$toast("结束时间不能为空");
                return;
            }
            if (this.value2 == "") {
                this.$toast("结束时间点不能为空");
                return;
            }
            let params = {
                type_id: this.$route.query.id,
                user_phone: this.mobile,
                theme: this.object,
                explain: this.speak,
                start_time: this.startTime + " " + this.value1,
                end_time: this.endTime + " " + this.value2
            };
            let _this=this

            this.$confirm("确定要对当前数据进行提交吗?", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消"
            })
                .then(() => {
                    this.$post("/api/Order/save_device_appointment", params)
                        .then(res => {
                            if (res.code == 1) {
                                _this.$toast(res.msg);
                                setTimeout(() => {
                                    _this.$router.replace("/appointment");
                                }, 1500);
                            }else{
                                _this.$toast(res.msg);
                            }
                        })
                        .catch(err => {
                            console.log(err);
                        });
                })
                .catch(() => {});
        },
        details() {
            let params = {
                    id: this.$route.query.id,
                    time: this.time
                },
                result = this.timelist,
                resultApply = [];

            this.$post("/api/Device/device_info", params)
                .then(res => {
                    if (res.code == 1) {
                        for(var i in result){
                            for(var j in res.data.time){
                                if(res.data.time[j].type==2){
                                    if(result[i].time==res.data.time[j].time){
                                        result[i].type=2
                                    }
                                }else if(res.data.time[j].type==3){
                                    if(result[i].time==res.data.time[j].time){
                                        result[i].type=3
                                    }
                                }
                            }
                        }
                        this.timelist = result;
                        this.device_info = res.data.device_info;
                        // this.apply = res.data.apply;
                        // this.pass = res.data.pass;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },

        timeList() {
            let time = [],
                items = "",
                category = ["00", "15","30", "45"];
            for (var cat in category) {
                for (var i = 0; i < 24; i++) {
                    if (i < 10) {
                        items = {
                            time: "0" + i + ":" + category[cat],
                            type: 1
                        };
                    } else {
                        items = { time: i + ":" + category[cat], type: 1 };
                    }
                    time.push(items);
                }
            }
            var compare = function(obj1, obj2) {
                var val1 = obj1.time;
                var val2 = obj2.time;
                if (val1 < val2) {
                    return -1;
                } else if (val1 > val2) {
                    return 1;
                } else {
                    return 0;
                }
            };
            this.timelist = time.sort(compare);
        }
    },
    mounted() {
        this.timeList();

        this.details();
    }
};
</script>
<style lang="less" scoped>
.content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 21px;
    display: flex;
    .rg {
        width: 838px;
        height: 80px;
        // line-height: 80px;
        background: #ffffff;
        margin-left: 21px;
        .tit {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .l {
                display: flex;
                height: 100%;
                align-items: center;
                img {
                    width: 5px;
                    height: 24px;
                }
                .tc {
                    font-size: 24px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    color: #333333;
                    padding-left: 13px;
                }
            }
        }
        .details {
            width: 838px;
            height: auto;
            background: #ffffff;
            margin-top: 21px;
            .title {
                display: flex;
                height: 43px;
                align-items: center;
                .ricle {
                    width: 4px;
                    height: 4px;
                    background: #ffffff;
                    border: 3px solid #3449d3;
                    border-radius: 50%;
                    margin-left: 20px;
                }
                .txt {
                    font-size: 18px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    text-align: left;
                    color: #333333;
                    padding-left: 14px;
                }
            }
            .line {
                width: 793px;
                border: 1px dashed #eaecfa;
                margin-left: 20px;
            }

            .time-select {
                display: flex;
                flex-direction: column;
                margin-left: 45px;
                .start {
                    display: flex;
                    align-items: center;
                    margin-bottom: 30px;
                    .start-time {
                        font-size: 16px;
                    }
                }
                .end {
                    display: flex;
                    align-items: center;
                    .start-time {
                        font-size: 16px;
                    }
                }
            }

            .lk {
                display: flex;
                height: 40px;
                align-items: center;
                padding-left: 45px;
                padding-top: 20px;
                label {
                    width: 77px;
                    font-size: 15px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #333333;
                    letter-spacing: 0px;
                }
                input {
                    width: 250px;
                    height: 40px;
                    border: 1px solid #d9ddf1;
                    border-radius: 4px;
                    margin-left: 16px;
                    padding-left: 10px;
                    font-size: 14px;
                    &::placeholder {
                        color: #999999;
                    }
                }
                textarea {
                    width: 332px;
                    height: 76px;
                    border: 1px solid #d9ddf1;
                    border-radius: 4px;
                    margin-left: 15px;
                    margin-top: 40px;
                    padding: 10px 0 0 8px;
                    font-size: 14px;
                }
            }

            .zhushi {
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #333333;
                padding: 27px 0 60px 40px;
            }
            .replay {
                display: flex;
                height: 44px;
                align-items: center;
                width: 100%;
                justify-content: center;
                padding-bottom: 60px;
                .left {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #3449d3;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    margin-right: 50px;
                    cursor: pointer;
                }
                .right {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #6480ec;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
